import {
  ACC_DESCRIPTION_FOR_SIDE_PANEL,
  ACC_TITLE_FOR_SIDE_PANEL,
  APPLICATION,
  CHILD_ENT_DESCRIPTION_FOR_SIDE_PANEL,
  ENT_DESCRIPTION_FOR_SIDE_PANEL,
  ENT_TITLE_FOR_SIDE_PANEL,
  EO_FIXED_COL_FOR_ACCOUNT,
  EO_FIXED_COL_FOR_CHILD_ENTITLEMENT,
  EO_FIXED_COL_FOR_ENTITLEMENT,
  RLE_DESCRIPTION_FOR_SIDE_PANEL,
  RLE_TITLE_FOR_SIDE_PANEL,
  SIDE_PANEL_CATEGORY_ACC,
  SIDE_PANEL_CATEGORY_CHILD_ENT,
  SIDE_PANEL_CATEGORY_ENT,
  SIDE_PANEL_CATEGORY_RLE,
  SIDE_PANEL_CATEGORY_USR,
  USR_DESCRIPTION_FOR_SIDE_PANEL,
  USR_TITLE_FOR_SIDE_PANEL,
} from './constant';

export const getKeysForSidePanelHeader = (isEOCampaign, key) => {
  if (isEOCampaign) {
    if (key === SIDE_PANEL_CATEGORY_ACC) {
      return {
        title: EO_FIXED_COL_FOR_ACCOUNT,
        desc: ACC_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }

    if (key === SIDE_PANEL_CATEGORY_ENT) {
      return {
        title: EO_FIXED_COL_FOR_ENTITLEMENT,
        desc: ENT_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }

    if (key === SIDE_PANEL_CATEGORY_CHILD_ENT) {
      return {
        title: EO_FIXED_COL_FOR_CHILD_ENTITLEMENT,
        desc: CHILD_ENT_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }
  } else {
    if (key === SIDE_PANEL_CATEGORY_USR) {
      return {
        title: USR_TITLE_FOR_SIDE_PANEL,
        desc: USR_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }

    if (key === SIDE_PANEL_CATEGORY_RLE) {
      return {
        title: RLE_TITLE_FOR_SIDE_PANEL,
        desc: RLE_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }

    if (key === SIDE_PANEL_CATEGORY_ACC) {
      return {
        title: ACC_TITLE_FOR_SIDE_PANEL,
        desc: ACC_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }

    if (key === SIDE_PANEL_CATEGORY_ENT) {
      return {
        title: ENT_TITLE_FOR_SIDE_PANEL,
        desc: ENT_DESCRIPTION_FOR_SIDE_PANEL,
      };
    }
  }

  return {};
};

export const setIcon = (type) => {
  switch (type) {
    case SIDE_PANEL_CATEGORY_USR:
      return 'UserBg';
    case SIDE_PANEL_CATEGORY_RLE:
      return 'role';
    case SIDE_PANEL_CATEGORY_ACC:
      return 'account';
    case SIDE_PANEL_CATEGORY_ENT:
    case SIDE_PANEL_CATEGORY_CHILD_ENT:
      return 'entitlement';
    default:
      return APPLICATION;
  }
};

export default { getKeysForSidePanelHeader, setIcon };
